module.exports = __webpack_public_path__ + "static/media/splash-tryvia.30804266.png";